<div class="row controls" *ngIf="formSections.length > 0">
  <rad-button class="rad-theme--light" variant="tertiary" size="small" icon-name-before="plus" type="button" (click)="expandAll()" data-cy="expandall-btn">
    Expand All
  </rad-button>
  <rad-button class="rad-theme--light" variant="tertiary" size="small" icon-name-before="minus" type="button" (click)="collapseAll()" data-cy="collapseall-btn">
    Collapse All
  </rad-button>
</div>

<form class="mb-5" [formGroup]="myFormGroup" spellcheck="false" novalidate>
  <ng-container *ngFor="let field of unsectionedFormFields">
    <ng-container *ngTemplateOutlet="fieldComponent; context: { field: field, showHyperlinkInDescription: showHyperlinkInDescription }"></ng-container>
  </ng-container>

  <ng-container *ngFor="let section of formSections; trackBy: trackBySectionId">
    <ng-container *ngIf="section.fields.length === 0">
      <!-- By right a section should not be empty, but if it happens to be so, display as a simple text header instead of accordion -->
      <div class="form-group section-header-non-collapsible">
        {{ section.label }}
      </div>
    </ng-container>
    <ng-container *ngIf="section.fields.length > 0">
      <rad-accordion [attr.expanded]="section.expanded" [attr.header]="section.label" (closed)="onSectionClosed(section)" (opened)="onSectionOpened(section)">
        <div slot="content" >
          <ng-container *ngFor="let field of section.fields">
            <ng-container *ngTemplateOutlet="fieldComponent; context: { field: field, showHyperlinkInDescription: showHyperlinkInDescription }"></ng-container>
          </ng-container>
        </div>
      </rad-accordion>
    </ng-container>
  </ng-container>

  <ng-template #fieldMessages let-fieldId="fieldId">
    <div class="error-message" *ngFor="let msg of renderErrorsByFieldId[fieldId]">
      <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
      <span>{{msg}}</span>
    </div>
    <div class="warning-message" *ngFor="let msg of renderWarningsByFieldId[fieldId]">
      <rad-icon name="exclamationCircle" size="sm"></rad-icon>
      <span>{{msg}}</span>
    </div>
  </ng-template>

  <ng-template #fieldComponent let-field="field" let-showHyperlinkInDescription="showHyperlinkInDescription">
    <div *ngIf="field.type === 'text' && !field.hidden" class="form-group row">
      <div class="col"><h4 [class.mandatory-field]="field.required">{{field.label}}</h4>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover></div>
    </div>

    <!-- Textbox -->
    <div *ngIf="field.type === 'textbox' && !field.hidden && (!hideOverrideCyclesField || field.id !== 'OverrideCycles')" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <lib-form-field [label]=""
                        [attr.for]="field.id"
                        [hint]=""
                        [isValidateOnTouch]="true"
                        [errorMessage]="getErrorMessage(field)">
          <input lib-input
                  [id]="field.id"
                  [formControlName]="field.id"
                  type="text"
                  data-cy="dynamic-textbox">
        </lib-form-field>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- Number/Integer -->
    <div *ngIf="((field.type === 'integer' || field.type === 'number') && !field.hidden)" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <lib-form-field [label]=""
                        [attr.for]="field.id"
                        [hint]=""
                        [isValidateOnTouch]="true"
                        [errorMessage]="getErrorMessage(field)">
          <input lib-input
                  [id]="field.id"
                  [formControlName]="field.id"
                  type="number"
                  data-cy="dynamic-number-textbox">
        </lib-form-field>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- Radio -->
    <div *ngIf="(field.type === 'radio' && !field.hidden)" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <ng-container>
          <lib-radio-checkbox-group type="radio"
                                    [required]="field.required"
                                    [name]="field.id"
                                    [formControlName]="field.id"
                                    [options]="field.choices"
                                    valueProperty="value"
                                    labelProperty="text"
                                    data-cy="dynamic-radio">
          </lib-radio-checkbox-group>
        </ng-container>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- Checkbox -->
    <div *ngIf="(field.type === 'checkbox' && !field.hidden)" class="form-group row align-items-center">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label  [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6 pb-3">
        <!-- For checkbox, only one option will be given, and boolean value should be taken -->
        <lib-radio-checkbox
          [disabled]="myFormGroup.controls[field.id].disabled"
          [checked]="myFormGroup.controls[field.id].value"
          (change)="onCheckBoxChange($event, field.id)"
          required="true"
          data-cy="dynamic-checkbox">
        </lib-radio-checkbox>
        <div class="error-message" *ngIf="getErrorMessage(field)">
          <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
          <span>{{getErrorMessage(field)}}</span>
        </div>
      </div>
    </div>

    <!-- Select (single) -->
    <div *ngIf="field.type === 'select' && !field.hidden && !isMultiSelect(field)" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <combobox placeholder="Select" [formControlName]="field.id" [label]="field.label" [enableDeleteBtn]="true"
                  data-cy="dynamic-select" #selectComboBox>
          <combobox-option *ngFor="let options of filterChoices(field.choices)" [value]="options.value"
                            [label]="options.text"></combobox-option>
        </combobox>
        <div *ngIf="myFormGroup.controls[field.id].touched && !myFormGroup.controls[field.id].valid && !myFormGroup.controls[field.id].errors.required" class="error-message">
          <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
          <span>{{getErrorMessage(field)}}</span>
        </div>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- Select (multi) -->
    <div *ngIf="field.type === 'select' && !field.hidden && isMultiSelect(field)" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <rad-select
          class="rad-theme--light"
          [attr.multiple]="true"
          [formControlName]="field.id"
          placeholder="Select items"
          data-cy="dynamic-multi-select">
          <rad-option
            *ngFor="let option of filterChoices(field.choices)"
            [attr.value]="option.value"
            [attr.label]="option.text">
          </rad-option>
        </rad-select>
        <div class="hint-text" *ngIf="field.settings">
          <ng-container *ngIf="field.settings.minSelection > 0 && field.settings.maxSelection">Select between {{field.settings.minSelection}} and {{field.settings.maxSelection}} items</ng-container>
          <ng-container *ngIf="field.settings.minSelection > 0 && !field.settings.maxSelection">Select at least {{field.settings.minSelection}} {{field.settings.minSelection > 1 ? 'items' : 'item'}}</ng-container>
          <ng-container *ngIf="!field.settings.minSelection || field.settings.minSelection === 0">Select up to {{field.settings.maxSelection}} items</ng-container>
        </div>
        <div *ngIf="(myFormGroup.controls[field.id].dirty || myFormGroup.controls[field.id].touched) && !myFormGroup.controls[field.id].valid" class="error-message">
          <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
          <span>{{getErrorMessage(field)}}</span>
        </div>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- File Select (Reference File) -->
    <div *ngIf="field.type === 'fileSelect' && !field.hidden" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <app-file-select-dropdown
          [parentFormGroup]="myFormGroup"
          [formField]="field"
          [supportLocalUpload]="supportLocalUpload"
          [supportUnselect]="!field.required"
          [analysisVersionDefinitionId]="analysisVersionDefinitionId"
          data-cy="dynamic-app-file-select-dropdown">
        </app-file-select-dropdown>
        <div *ngIf="myFormGroup.controls[field.id].touched && !myFormGroup.controls[field.id].valid && !myFormGroup.controls[field.id].errors.required" class="error-message">
          <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
          <span>{{getErrorMessage(field)}}</span>
        </div>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- Genome (Reference Genome) -->
    <div *ngIf="field.type === 'genome' && !field.hidden" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <app-genome-dropdown
          [genomeFormControlName]="field.id"
          [fieldLabel]="field.label"
          [showHyperlinkInDescription]="showHyperlinkInDescription"
          [analysisVersionDefinitionId]="analysisVersionDefinitionId"
          [filterBySampleSheetFormat]="filterBySampleSheetFormat"
          [settings]="field.settings"
          data-cy="dynamic-app-genome-dropdown">
        </app-genome-dropdown>
        <div *ngIf="myFormGroup.controls[field.id].touched && !myFormGroup.controls[field.id].valid && !myFormGroup.controls[field.id].errors.required" class="error-message">
          <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
          <span>{{getErrorMessage(field)}}</span>
        </div>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- Reference File -->
    <div *ngIf="field.type === 'referenceFile' && !field.hidden" class="form-group row">
      <div class="col-3 col-lg-2 col-md-4 col-sm-8 word-break">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <!-- Tooltip -->
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
      </div>
      <div class="col-6">
        <app-reference-file-dropdown
          [referenceFileFormControlName]="field.id"
          [referenceFileFieldSettings]="field.settings"
          [referenceFileGenomeFilterFieldId]="(field.settings && field.settings.referenceFileGenomeFilterFieldId) || null"
          [genomeFilterGenomeId]="field.genomeFilterGenomeId"
          [referenceFileTypeFilter]="(field.settings && field.settings.referenceFileTypeFilter) || null"
          [genomeHashTableVersion]="field.settings.referenceFileGenomeHashTableVersion"
          [analysisVersionDefinitionId]="analysisVersionDefinitionId"
          [isRequired]="field.required"
          [fieldLabel]="field.label"
          [disableReferenceFileUpload]="disableReferenceFileUpload"
          (newReferenceFileAdded)="onNewReferenceFileAdded($event)"
          [newReferenceFileName$]="newlyAddedReferenceFile$"
        >
        </app-reference-file-dropdown>
        <div *ngIf="myFormGroup.controls[field.id].touched && !myFormGroup.controls[field.id].valid && !myFormGroup.controls[field.id].errors.required" class="error-message">
          <rad-icon name="exclamationTriangle" size="sm"></rad-icon>
          <span>{{getErrorMessage(field)}}</span>
        </div>
        <ng-container *ngTemplateOutlet="fieldMessages; context: { fieldId: field.id }"></ng-container>
      </div>
    </div>

    <!-- FieldGroup -->
    <div *ngIf="field.type === 'fieldgroup' && !field.hidden" class="form-group row">
      <div class="col-12">
        <label [class.mandatory-field]="field.required">{{field.label}}</label>
        <lib-popover
          style="vertical-align:'text-bottom'"
          *ngIf="field.helpText"
          popoverType="info"
          popoverSize="medium"
          popoverPlacement="right">
          <app-description-text
            [description]="field.helpText"
            [parseAsMarkdown]="showHyperlinkInDescription"
            [checkFromIllumina]="true">
          </app-description-text>
        </lib-popover>
        <app-fieldgroup-table
          [columns]="field.fields"
          [fieldGroupId]="field.id"
          [formControlName]="field.id"
          [minRows]="field.minFieldGroupInstances"
          [maxRows]="field.maxFieldGroupInstances"
          [allSettingsFormValues]="allSettingsFormValues"
          [analysisVersionDefinitionId]="analysisVersionDefinitionId"
          [analysisLocation]="analysisLocation"
          [showHyperlinkInDescription]="showHyperlinkInDescription">
        </app-fieldgroup-table>
      </div>
    </div>
  </ng-template>
</form>
